export const STAR_SIZE_CLASS = {
	sm: 'h-[12px] w-[12px]',
	md: 'h-[16px] w-[16px]',
	lg: 'h-[20px] w-[20px]',
} as const;

export const DEFAULT_MAX = 5;
